import { Box, Typography } from '@mui/material';
import { FC, useMemo } from 'react';
import { flipToPositive, formatPounds } from '@acorn-portal/shared/src/utils';
import { Product } from '@acorn-portal/shared/src/services/interface/Shared';

interface IPriceBreakdown {
	price?: number;
	fee?: number;
	product: Product;
}

const PriceBreakdown: FC<IPriceBreakdown> = ({ price, fee = 0, product }) => {
	const parsedEnvVars = useMemo(() => {
		const adminFee = parseFloat(import.meta.env.VITE_ADMIN_FEE);

		const telematicsDeviceFee = parseFloat(import.meta.env.VITE_TELEMATIC_DEVICE_FEE);
		const telematicsCradleFee = parseFloat(import.meta.env.VITE_TELEMATIC_CRADLE_FEE);
		const telematicIMS = parseFloat(import.meta.env.VITE_TELEMATIC_IMS_FEE);

		return {
			adminFee,
			telematicsDeviceFee,
			telematicsCradleFee,
			telematicIMS,
		};
	}, []);

	if (price === undefined) return null;

	const { adminFee, telematicsDeviceFee, telematicsCradleFee, telematicIMS } = parsedEnvVars;

	const formattedPrice = price > 0 ? formatPounds(price - fee) : formatPounds(flipToPositive(price) + fee);

	return (
		<Box>
			{Boolean(fee > 0) && (
				<Typography marginTop={2} fontSize={14}>
					{formattedPrice} {price > 0 ? 'Premium' : 'Return Premium'}
				</Typography>
			)}
			<Typography fontSize={12}>Inclusive of {import.meta.env.VITE_IPT_PERCENTAGE}% Insurance Premium Tax</Typography>
			{Boolean(fee && product !== Product.TELEMATICS) && (
				<Typography fontSize={12}>{formatPounds(fee)} Non-refundable Administration Fee</Typography>
			)}

			{fee === adminFee && product === Product.TELEMATICS && (
				<Typography fontSize={12}>{formatPounds(fee)} Non-refundable Administration Fee</Typography>
			)}

			{fee === telematicsDeviceFee + adminFee && (
				<>
					<Typography fontSize={12}>{formatPounds(adminFee)} Non-refundable Administration Fee</Typography>
					<Typography fontSize={12}>{formatPounds(telematicsDeviceFee)} Telematics Device Fee</Typography>
				</>
			)}
			{fee === telematicsCradleFee + adminFee && (
				<>
					<Typography fontSize={12}>{formatPounds(adminFee)} Non-refundable Administration Fee</Typography>
					<Typography fontSize={12}>{formatPounds(telematicsCradleFee)} Telematics Cradle Fee</Typography>
				</>
			)}
			{fee === telematicIMS + adminFee && (
				<>
					<Typography fontSize={12}>{formatPounds(adminFee)} Non-refundable Administration Fee</Typography>
					<Typography fontSize={12}>{formatPounds(telematicIMS)} Telematics Device Fee</Typography>
				</>
			)}
		</Box>
	);
};

export default PriceBreakdown;
